// PRD §2.1 — orchestrator: 2-column layout matching the prototype
// (`prototype/pages/pro-structure.html`). Left = tree panel (30%, min 300px),
// right = detail panel (flex). Both scroll independently within
// calc(100vh - 180px).

import { ProDetailPanel } from './ProDetailPanel';
import { ProTreePanel } from './ProTreePanel';
import { UnsavedChangesModal } from './UnsavedChangesModal';
import { useMergedProTree } from '../hooks/use-pro-tree';

export function ProItemDesignView() {
  // SHCT-388 — merged tree includes the not-yet-persisted Add draft.
  const { tree, isLoading, isError } = useMergedProTree();

  return (
    <>
      <div style={{ display: 'flex', gap: 16, minHeight: 'calc(100vh - 180px)' }}>
        <ProTreePanel tree={tree} isLoading={isLoading} isError={isError} />
        <ProDetailPanel />
      </div>
      {/* Slice 13 — unsaved-changes guard. Mounted once at the page level so
          any user-initiated navigation can park its target via the store. */}
      <UnsavedChangesModal />
    </>
  );
}
